



















































































import Vue from 'vue';
import * as operatoreSanitarioApi from '../../services/operatore-sanitario-api';
import { OperatoreSanitarioEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';
import EnteSanitarioSelector from '../selectors/EnteSanitarioSelector.vue';
import AttributoSelector from '../selectors/AttributoSelector.vue';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: { EnteSanitarioSelector, AttributoSelector },
    props: {
        fullSize: { default: false },
        id: { default: 0 },
    },
    data(): OperatoreSanitarioEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await operatoreSanitarioApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await operatoreSanitarioApi.create({
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                    qualificaId: this.item.qualificaId,
                    entiSanitariId: this.item.entiSanitariId,
                });
            } else {
                response = await operatoreSanitarioApi.update({
                    id: this.item.id,
                    version: this.item.version,
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                    qualificaId: this.item.qualificaId,
                    entiSanitariId: this.item.entiSanitariId,
                    attivo: this.item.attivo,
                });
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                nome: '',
                cognome: '',
                qualificaId: 0,
                entiSanitariId: null,
                attivo: true,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
